import { render, staticRenderFns } from "./FmrRequestedAuthorization.vue?vue&type=template&id=1b0ab07e&scoped=true"
import script from "./FmrRequestedAuthorization.vue?vue&type=script&lang=js"
export * from "./FmrRequestedAuthorization.vue?vue&type=script&lang=js"
import style0 from "./FmrRequestedAuthorization.vue?vue&type=style&index=0&id=1b0ab07e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b0ab07e",
  null
  
)

export default component.exports